export function formatHourToBackend(hour: string): string {
  if (!hour) return hour; // Retorna null/undefined se o valor for vazio
  if (hour.includes(':') && hour.length === 8) {
    return hour; // Já está no formato HH:MM:SS
  }
  if (hour.length === 6) {
    return `${hour.substring(0, 2)}:${hour.substring(2, 4)}:${hour.substring(4, 6)}`;
  }
  return hour; // Retorna o valor original se não corresponder aos formatos esperados
}